/**
 * useLevelHome
 *
 * Encapsulates the "clear save data" confirmation dialog logic
 * that was manually building DOM nodes in level_home.js.
 *
 * Returns reactive state + handlers to bind to ConfirmDialog.vue.
 */
import { ref } from 'vue';
import { emptyLevels } from '../scripts/boot.js';

export function useLevelHome() {
  const dialogVisible = ref(false);
  const dialogMessage = ref('');
  const dialogShowActions = ref(true);

  const openClearDialog = () => {
    dialogMessage.value = 'Do you want to clear the data? 🚮';
    dialogShowActions.value = true;
    dialogVisible.value = true;
  };

  const onConfirm = () => {
    emptyLevels();
    dialogShowActions.value = false;
    dialogMessage.value = 'Your data has been successfully cleared ✅';
  };

  const onCancel = () => {
    dialogVisible.value = false;
  };

  const onClose = () => {
    dialogVisible.value = false;
  };

  window.__openClearDialog = openClearDialog;

  return {
    dialogVisible,
    dialogMessage,
    dialogShowActions,
    openClearDialog,
    onConfirm,
    onCancel,
    onClose,
  };
}
